import { render, staticRenderFns } from "./HeroHeader.vue?vue&type=template&id=5aae43d0&scoped=true"
import script from "./HeroHeader.vue?vue&type=script&lang=js"
export * from "./HeroHeader.vue?vue&type=script&lang=js"
import style0 from "./HeroHeader.vue?vue&type=style&index=0&id=5aae43d0&prod&lang=scss&scoped=true"
import style1 from "./HeroHeader.vue?vue&type=style&index=1&id=5aae43d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae43d0",
  null
  
)

export default component.exports